/**CORE LIBRARIES IMPORT */
import React from "react";

/**COMPONENTS IMPORT */
import BrandLogo from "./BrandLogo";

/**DATA IMPORT */
import { brands } from "../data/brand";

/** Two official logos side by side for joint events: "A × B". */
const PartnerLockup = ({ partners = ["greyWolf", "lysters"], label, className = "" }) => (
  <div className={`partner-lockup ${className}`}>
    <div className="partner-logos">
      {partners.map((key, i) => (
        <React.Fragment key={key}>
          {i > 0 && <span className="partner-x" aria-hidden="true">×</span>}
          <span className={`partner-plate partner-plate-${key}`}>
            <BrandLogo brand={key} size={key === "lysters" ? 180 : 110} />
          </span>
        </React.Fragment>
      ))}
    </div>
    <p className="partner-label">
      {label || partners.map((key) => brands[key].name).join(" × ")}
    </p>
  </div>
);

export default PartnerLockup;
